import React, { createContext, useContext, useMemo } from 'react';
import { ProfileContextType } from '@tv2/lib-offspring/components/profile/ProfileProviderContextType';
import { Profile } from '@tv2/lib-offspring/components/profile/types';

export type ProfileAction = {
  title: string;
  altTitle: string;
  drawerTitle: string;
  link: string;
  restricted: boolean;
};

type LeanProfileContextType = {
  profile: ProfileContextType;
  profiles: Profile[];
  actions: ProfileAction[];
};

const LeanProfileContext = createContext<LeanProfileContextType>({
  profile: {
    isParentalControlled: false,
    completed: false,
    shouldRedirect: false,
    profile: null,
    profiles: [],
    profileTracking: null,
    setCurrentProfile: () => {},
    refetchProfiles: () => Promise.resolve(),
  },
  profiles: [],
  actions: [],
});

export default function LeanProfileProvider({
  children,
  profile,
  profiles,
  actions,
}: {
  children: React.ReactNode;
  profile: ProfileContextType;
  profiles: Profile[];
  actions: ProfileAction[];
}) {
  const value = useMemo(
    () => ({
      profile,
      profiles,
      actions,
    }),
    [actions, profile, profiles]
  );

  return <LeanProfileContext.Provider value={value}>{children}</LeanProfileContext.Provider>;
}

export function useLeanProfile() {
  const profile = useContext(LeanProfileContext);
  return profile;
}
